import samsungcharger from '../assets/images/accessories/samsungcharger.webp'
import xiaomicarcharger from '../assets/images/accessories/xiaomicarcharger.webp'
import belkincable1 from '../assets/images/accessories/belkincable.jpg'
import ankercable from '../assets/images/accessories/ankercable.webp'
import ankerpowerbank from '../assets/images/accessories/ankerpowerbank.webp'
import spigen from '../assets/images/accessories/spigen.webp'
import remote from '../assets/images/accessories/remote.webp'
import airpod from '../assets/images/accessories/airpod.webp'
export const accessories = [
    {
        id: 301,
        name: "Samsung 25W Super Fast Charger Type-C with Cable",
        brand: "Samsung",
        category: "Accessories",
        type: "Chargers",
        price: 2499,
        originalPrice: 3499,
        discount: 29,
        image: samsungcharger,
        rating: 4.6,
        reviews: 892,
        compatibility: "Mobile",
        connectivity: "Wired",
        powerOutput: "25W",
        stock: 156,
        emi: "KSh 208/mo",
        kcbOffer: true,
        features: "Fast Charging, Type-C Cable Included",
        releaseDate: "2024-01-15",
        sales: 2340
    },
    {
        id: 302,
        name: "Apple AirPods Pro 2nd Generation with MagSafe Charging",
        brand: "Apple",
        category: "Accessories",
        type: "Earphones",
        price: 34999,
        originalPrice: 39999,
        discount: 13,
        image: airpod,
        rating: 4.9,
        reviews: 1567,
        compatibility: "Mobile",
        connectivity: "Wireless",
        powerOutput: "N/A",
        stock: 89,
        emi: "KSh 2,917/mo",
        kcbOffer: true,
        features: "Active Noise Cancellation, Spatial Audio",
        releaseDate: "2024-02-10",
        sales: 1890
    },
    {
        id: 303,
        name: "Anker PowerCore 20000mAh Power Bank Fast Charging",
        brand: "Anker",
        category: "Accessories",
        type: "Power Banks",
        price: 4999,
        originalPrice: 6999,
        discount: 29,
        image: ankerpowerbank,
        rating: 4.7,
        reviews: 2134,
        compatibility: "Mobile",
        connectivity: "Wired",
        powerOutput: "18W",
        stock: 234,
        emi: "KSh 417/mo",
        kcbOffer: false,
        features: "20000mAh, Dual USB Ports",
        releaseDate: "2023-11-20",
        sales: 3456
    },
    {
        id: 304,
        name: "Belkin USB-C to USB-C Cable 2m Braided Fast Charge",
        brand: "Belkin",
        category: "Accessories",
        type: "Cables",
        price: 1299,
        originalPrice: 1899,
        discount: 32,
        image: belkincable1,
        rating: 4.5,
        reviews: 678,
        compatibility: "Mobile",
        connectivity: "Wired",
        powerOutput: "100W",
        stock: 456,
        emi: "KSh 108/mo",
        kcbOffer: false,
        features: "2m Length, 100W Power Delivery",
        releaseDate: "2023-12-05",
        sales: 4567
    },
    {
        id: 305,
        name: "Spigen Rugged Armor Case for iPhone 15 Pro Max",
        brand: "Spigen",
        category: "Accessories",
        type: "Covers",
        price: 2199,
        originalPrice: 2999,
        discount: 27,
        image: spigen,
        rating: 4.8,
        reviews: 1234,
        compatibility: "Mobile",
        connectivity: "N/A",
        powerOutput: "N/A",
        stock: 178,
        emi: "KSh 183/mo",
        kcbOffer: false,
        features: "Military Grade Protection, Carbon Fiber Design",
        releaseDate: "2024-01-08",
        sales: 2890
    },
    {
        id: 306,
        name: "Samsung Galaxy Buds2 Pro Wireless Earbuds Graphite",
        brand: "Samsung",
        category: "Accessories",
        type: "Earphones",
        price: 18999,
        originalPrice: 24999,
        discount: 24,
        image: airpod,
        rating: 4.7,
        reviews: 987,
        compatibility: "Mobile",
        connectivity: "Wireless",
        powerOutput: "N/A",
        stock: 123,
        emi: "KSh 1,583/mo",
        kcbOffer: true,
        features: "ANC, 360 Audio, IPX7 Water Resistant",
        releaseDate: "2024-02-20",
        sales: 1567
    },
    {
        id: 307,
        name: "Xiaomi 33W Fast Charger with Type-C Cable White",
        brand: "Xiaomi",
        category: "Accessories",
        type: "Chargers",
        price: 1799,
        originalPrice: 2499,
        discount: 28,
        image: xiaomicarcharger,
        rating: 4.4,
        reviews: 1456,
        compatibility: "Mobile",
        connectivity: "Wired",
        powerOutput: "33W",
        stock: 289,
        emi: "KSh 150/mo",
        kcbOffer: false,
        features: "33W Fast Charging, Compact Design",
        releaseDate: "2023-10-15",
        sales: 3890
    },
    {
        id: 308,
        name: "Baseus 30000mAh Power Bank 65W Laptop Charging",
        brand: "Baseus",
        category: "Accessories",
        type: "Power Banks",
        price: 7999,
        originalPrice: 10999,
        discount: 27,
        image: ankercable,
        rating: 4.8,
        reviews: 756,
        compatibility: "Mobile",
        connectivity: "Wired",
        powerOutput: "65W",
        stock: 167,
        emi: "KSh 667/mo",
        kcbOffer: true,
        features: "30000mAh, 65W PD, Digital Display",
        releaseDate: "2024-01-25",
        sales: 1234
    },
    {
        id: 309,
        name: "JBL Tune 510BT Wireless On-Ear Headphones Black",
        brand: "JBL",
        category: "Accessories",
        type: "Earphones",
        price: 4499,
        originalPrice: 5999,
        discount: 25,
        image: ankerpowerbank,
        rating: 4.6,
        reviews: 1890,
        compatibility: "Mobile",
        connectivity: "Wireless",
        powerOutput: "N/A",
        stock: 201,
        emi: "KSh 375/mo",
        kcbOffer: false,
        features: "40hrs Battery, Foldable, Bluetooth 5.0",
        releaseDate: "2023-09-10",
        sales: 2678
    },
    {
        id: 310,
        name: "UGREEN USB-C Hub 7-in-1 for MacBook iPad Pro",
        brand: "UGREEN",
        category: "Accessories",
        type: "Cables",
        price: 3999,
        originalPrice: 5499,
        discount: 27,
        image: xiaomicarcharger,
        rating: 4.7,
        reviews: 543,
        compatibility: "Tablet",
        connectivity: "Wired",
        powerOutput: "100W",
        stock: 134,
        emi: "KSh 333/mo",
        kcbOffer: false,
        features: "7-in-1, 4K HDMI, 100W PD",
        releaseDate: "2024-02-01",
        sales: 987
    },
    {
        id: 311,
        name: "OtterBox Defender Series Case Samsung Galaxy S24 Ultra",
        brand: "OtterBox",
        category: "Accessories",
        type: "Covers",
        price: 4999,
        originalPrice: 6999,
        discount: 29,
        image: ankerpowerbank,
        rating: 4.9,
        reviews: 876,
        compatibility: "Mobile",
        connectivity: "N/A",
        powerOutput: "N/A",
        stock: 98,
        emi: "KSh 417/mo",
        kcbOffer: true,
        features: "Triple Layer Protection, Port Covers",
        releaseDate: "2024-02-15",
        sales: 1456
    },
    {
        id: 312,
        name: "Anker Nano II 65W GaN Fast Charger Ultra Compact",
        brand: "Anker",
        category: "Accessories",
        type: "Chargers",
        price: 4499,
        originalPrice: 5999,
        discount: 25,
        image: airpod,
        rating: 4.8,
        reviews: 1123,
        compatibility: "Mobile",
        connectivity: "Wired",
        powerOutput: "65W",
        stock: 187,
        emi: "KSh 375/mo",
        kcbOffer: true,
        features: "65W GaN Technology, 3x Smaller",
        releaseDate: "2024-01-10",
        sales: 2134
    },
    {
        id: 313,
        name: "Sony WH-1000XM5 Wireless Noise Cancelling Headphones",
        brand: "Sony",
        category: "Accessories",
        type: "Earphones",
        price: 39999,
        originalPrice: 44999,
        discount: 11,
        image: ankercable,
        rating: 4.9,
        reviews: 2345,
        compatibility: "Mobile",
        connectivity: "Wireless",
        powerOutput: "N/A",
        stock: 67,
        emi: "KSh 3,333/mo",
        kcbOffer: true,
        features: "Industry-Leading ANC, 30hrs Battery",
        releaseDate: "2024-03-01",
        sales: 1678
    },
    {
        id: 314,
        name: "Mophie Powerstation Plus 10000mAh Built-in Cables",
        brand: "Mophie",
        category: "Accessories",
        type: "Power Banks",
        price: 5999,
        originalPrice: 7999,
        discount: 25,
        image: ankerpowerbank,
        rating: 4.6,
        reviews: 678,
        compatibility: "Mobile",
        connectivity: "Wired",
        powerOutput: "18W",
        stock: 145,
        emi: "KSh 500/mo",
        kcbOffer: false,
        features: "Built-in Lightning & USB-C Cables",
        releaseDate: "2023-11-15",
        sales: 1890
    },
    {
        id: 315,
        name: "Logitech K380 Multi-Device Bluetooth Keyboard",
        brand: "Logitech",
        category: "Accessories",
        type: "Cables",
        price: 3499,
        originalPrice: 4999,
        discount: 30,
        image:samsungcharger,
        rating: 4.7,
        reviews: 1456,
        compatibility: "Tablet",
        connectivity: "Wireless",
        powerOutput: "N/A",
        stock: 223,
        emi: "KSh 292/mo",
        kcbOffer: false,
        features: "Multi-Device, 2-Year Battery Life",
        releaseDate: "2023-08-20",
        sales: 2567
    },
    {
        id: 316,
        name: "Ringke Fusion-X Case for Xiaomi 14 Pro Clear Back",
        brand: "Ringke",
        category: "Accessories",
        type: "Covers",
        price: 1799,
        originalPrice: 2499,
        discount: 28,
        image: spigen,
        rating: 4.5,
        reviews: 789,
        compatibility: "Mobile",
        connectivity: "N/A",
        powerOutput: "N/A",
        stock: 267,
        emi: "KSh 150/mo",
        kcbOffer: false,
        features: "Clear Back, Military Grade Drop Protection",
        releaseDate: "2024-01-20",
        sales: 2234
    },
    {
        id: 317,
        name: "Belkin BoostCharge Pro 3-in-1 Wireless Charging Stand",
        brand: "Belkin",
        category: "Accessories",
        type: "Chargers",
        price: 14999,
        originalPrice: 18999,
        discount: 21,
        image: belkincable1,
        rating: 4.8,
        reviews: 567,
        compatibility: "Mobile",
        connectivity: "Wireless",
        powerOutput: "15W",
        stock: 89,
        emi: "KSh 1,250/mo",
        kcbOffer: true,
        features: "3-in-1, MagSafe Compatible, 15W Fast Charge",
        releaseDate: "2024-02-05",
        sales: 1123
    },
    {
        id: 318,
        name: "Sennheiser Momentum True Wireless 3 Earbuds Black",
        brand: "Sennheiser",
        category: "Accessories",
        type: "Earphones",
        price: 29999,
        originalPrice: 34999,
        discount: 14,
        image: ankercable,
        rating: 4.8,
        reviews: 456,
        compatibility: "Mobile",
        connectivity: "Wireless",
        powerOutput: "N/A",
        stock: 78,
        emi: "KSh 2,500/mo",
        kcbOffer: true,
        features: "Adaptive ANC, Audiophile Sound, 28hrs Battery",
        releaseDate: "2024-02-28",
        sales: 890
    },
    {
        id: 319,
        name: "RAVPower 26800mAh Power Bank 30W PD Fast Charging",
        brand: "RAVPower",
        category: "Accessories",
        type: "Power Banks",
        price: 6499,
        originalPrice: 8999,
        discount: 28,
        image: airpod,
        rating: 4.7,
        reviews: 890,
        compatibility: "Mobile",
        connectivity: "Wired",
        powerOutput: "30W",
        stock: 156,
        emi: "KSh 542/mo",
        kcbOffer: false,
        features: "26800mAh, 30W PD, Triple Ports",
        releaseDate: "2023-12-10",
        sales: 1678
    },
    {
        id: 320,
        name: "Apple Lightning to USB-C Cable 1m Original",
        brand: "Apple",
        category: "Accessories",
        type: "Cables",
        price: 2499,
        originalPrice: 2999,
        discount: 17,
        image: airpod,
        rating: 4.9,
        reviews: 2345,
        compatibility: "Mobile",
        connectivity: "Wired",
        powerOutput: "20W",
        stock: 345,
        emi: "KSh 208/mo",
        kcbOffer: false,
        features: "MFi Certified, Fast Charging Support",
        releaseDate: "2023-09-01",
        sales: 4567
    },
    {
        id: 321,
        name: "UAG Pathfinder Case for Samsung Galaxy Z Fold 5",
        brand: "UAG",
        category: "Accessories",
        type: "Covers",
        price: 6999,
        originalPrice: 8999,
        discount: 22,
        image: spigen,
        rating: 4.8,
        reviews: 345,
        compatibility: "Mobile",
        connectivity: "N/A",
        powerOutput: "N/A",
        stock: 67,
        emi: "KSh 583/mo",
        kcbOffer: true,
        features: "Military Drop Tested, Wireless Charging Compatible",
        releaseDate: "2024-01-30",
        sales: 789
    },
    {
        id: 322,
        name: "Aukey Omnia 100W 4-Port GaN Charger Desktop Station",
        brand: "Aukey",
        category: "Accessories",
        type: "Chargers",
        price: 7999,
        originalPrice: 9999,
        discount: 20,
        image:samsungcharger,
        rating: 4.7,
        reviews: 456,
        compatibility: "Mobile",
        connectivity: "Wired",
        powerOutput: "100W",
        stock: 112,
        emi: "KSh 667/mo",
        kcbOffer: true,
        features: "100W Total Output, 4 Ports, GaN Technology",
        releaseDate: "2024-02-12",
        sales: 1234
    },
    {
        id: 323,
        name: "Bose QuietComfort Earbuds II Wireless ANC Black",
        brand: "Bose",
        category: "Accessories",
        type: "Earphones",
        price: 32999,
        originalPrice: 37999,
        discount: 13,
        image: airpod,
        rating: 4.9,
        reviews: 678,
        compatibility: "Mobile",
        connectivity: "Wireless",
        powerOutput: "N/A",
        stock: 89,
        emi: "KSh 2,750/mo",
        kcbOffer: true,
        features: "Personalized ANC, 6hrs Battery, IPX4",
        releaseDate: "2024-03-05",
        sales: 1123
    },
    {
        id: 324,
        name: "Zendure SuperMini 10000mAh Power Bank Ultra Compact",
        brand: "Zendure",
        category: "Accessories",
        type: "Power Banks",
        price: 3999,
        originalPrice: 5499,
        discount: 27,
        image: ankercable,
        rating: 4.6,
        reviews: 567,
        compatibility: "Mobile",
        connectivity: "Wired",
        powerOutput: "20W",
        stock: 198,
        emi: "KSh 333/mo",
        kcbOffer: false,
        features: "Credit Card Size, 10000mAh, 20W PD",
        releaseDate: "2023-10-25",
        sales: 2345
    },
    {
        id: 325,
        name: "Samsung TV Remote Control Universal Smart TV Compatible",
        brand: "Samsung",
        category: "Accessories",
        type: "Remotes",
        price: 1499,
        originalPrice: 1999,
        discount: 25,
        image: remote,
        rating: 4.5,
        reviews: 1234,
        compatibility: "TV",
        connectivity: "Wireless",
        powerOutput: "N/A",
        stock: 456,
        emi: "KSh 125/mo",
        kcbOffer: false,
        features: "Universal Compatibility, Voice Control",
        releaseDate: "2023-07-15",
        sales: 3456
    },
    {
        id: 326,
        name: "Casetify Impact Case Custom Design for iPhone 15",
        brand: "Casetify",
        category: "Accessories",
        type: "Covers",
        price: 3999,
        originalPrice: 4999,
        discount: 20,
        image: belkincable1,
        rating: 4.7,
        reviews: 890,
        compatibility: "Mobile",
        connectivity: "N/A",
        powerOutput: "N/A",
        stock: 178,
        emi: "KSh 333/mo",
        kcbOffer: false,
        features: "6.5ft Drop Protection, Customizable Design",
        releaseDate: "2024-01-15",
        sales: 1890
    },
    {
        id: 327,
        name: "Anker PowerLine III Flow USB-C to Lightning Cable 3ft",
        brand: "Anker",
        category: "Accessories",
        type: "Cables",
        price: 1799,
        originalPrice: 2499,
        discount: 28,
        image: ankercable,
        rating: 4.8,
        reviews: 1567,
        compatibility: "Mobile",
        connectivity: "Wired",
        powerOutput: "30W",
        stock: 389,
        emi: "KSh 150/mo",
        kcbOffer: false,
        features: "MFi Certified, Tangle-Free, 30W Fast Charge",
        releaseDate: "2023-11-01",
        sales: 3890
    },
    {
        id: 328,
        name: "Twelve South HiRise 3 Wireless Charging Stand Black",
        brand: "Twelve South",
        category: "Accessories",
        type: "Chargers",
        price: 9999,
        originalPrice: 12999,
        discount: 23,
        image: remote,
        rating: 4.8,
        reviews: 345,
        compatibility: "Mobile",
        connectivity: "Wireless",
        powerOutput: "15W",
        stock: 67,
        emi: "KSh 833/mo",
        kcbOffer: true,
        features: "3-in-1, Premium Aluminum, MagSafe Compatible",
        releaseDate: "2024-02-18",
        sales: 890
    },
    {
        id: 329,
        name: "Jabra Elite 85t True Wireless Earbuds Advanced ANC",
        brand: "Jabra",
        category: "Accessories",
        type: "Earphones",
        price: 21999,
        originalPrice: 26999,
        discount: 19,
        image: ankercable,
        rating: 4.7,
        reviews: 789,
        compatibility: "Mobile",
        connectivity: "Wireless",
        powerOutput: "N/A",
        stock: 123,
        emi: "KSh 1,833/mo",
        kcbOffer: true,
        features: "Advanced ANC, 25hrs Battery, IPX4",
        releaseDate: "2024-01-22",
        sales: 1456
    },
    {
        id: 330,
        name: "Xiaomi Car Charger 37W Dual USB Fast Charging",
        brand: "Xiaomi",
        category: "Accessories",
        type: "Chargers",
        price: 999,
        originalPrice: 1499,
        discount: 33,
        image: ankercable,
        rating: 4.6,
        reviews: 2345,
        compatibility: "Mobile",
        connectivity: "Wired",
        powerOutput: "37W",
        stock: 567,
        emi: "KSh 83/mo",
        kcbOffer: false,
        features: "Dual USB, Fast Charging, Aluminum Body",
        releaseDate: "2023-08-10",
        sales: 5678
    },
    {
        id: 331,
        name: "Logitech MX Master 3S Wireless Mouse Graphite",
        brand: "Logitech",
        category: "Accessories",
        type: "Cables",
        price: 11999,
        originalPrice: 14999,
        discount: 20,
        image: ankercable,
        rating: 4.9,
        reviews: 1234,
        compatibility: "Tablet",
        connectivity: "Wireless",
        powerOutput: "N/A",
        stock: 145,
        emi: "KSh 1,000/mo",
        kcbOffer: true,
        features: "8K DPI, Quiet Clicks, Multi-Device",
        releaseDate: "2024-02-25",
        sales: 1678
    },
    {
        id: 332,
        name: "Nomad Rugged Case for iPhone 15 Pro Horween Leather",
        brand: "Nomad",
        category: "Accessories",
        type: "Covers",
        price: 5999,
        originalPrice: 7999,
        discount: 25,
        image: ankerpowerbank,
        rating: 4.8,
        reviews: 456,
        compatibility: "Mobile",
        connectivity: "N/A",
        powerOutput: "N/A",
        stock: 89,
        emi: "KSh 500/mo",
        kcbOffer: true,
        features: "Horween Leather, 10ft Drop Protection",
        releaseDate: "2024-01-28",
        sales: 1123
    },
    {
        id: 333,
        name: "Philips TV Wall Mount Bracket 32-65 inch Tilt Swivel",
        brand: "Philips",
        category: "Accessories",
        type: "Mounts",
        price: 2999,
        originalPrice: 3999,
        discount: 25,
        image: ankerpowerbank,
        rating: 4.7,
        reviews: 678,
        compatibility: "TV",
        connectivity: "N/A",
        powerOutput: "N/A",
        stock: 234,
        emi: "KSh 250/mo",
        kcbOffer: false,
        features: "Tilt & Swivel, 32-65 inch, Easy Installation",
        releaseDate: "2023-06-20",
        sales: 2890
    },
    {
        id: 334,
        name: "Beats Fit Pro True Wireless Earbuds Stone Purple",
        brand: "Beats",
        category: "Accessories",
        type: "Earphones",
        price: 24999,
        originalPrice: 29999,
        discount: 17,
        image: ankercable,
        rating: 4.7,
        reviews: 890,
        compatibility: "Mobile",
        connectivity: "Wireless",
        powerOutput: "N/A",
        stock: 112,
        emi: "KSh 2,083/mo",
        kcbOffer: true,
        features: "Active ANC, Spatial Audio, IPX4",
        releaseDate: "2024-02-08",
        sales: 1567
    },
    {
        id: 335,
        name: "Romoss Sense 8+ 30000mAh Power Bank 18W Fast Charge",
        brand: "Romoss",
        category: "Accessories",
        type: "Power Banks",
        price: 4999,
        originalPrice: 6999,
        discount: 29,
        image: samsungcharger,
        rating: 4.6,
        reviews: 1123,
        compatibility: "Mobile",
        connectivity: "Wired",
        powerOutput: "18W",
        stock: 267,
        emi: "KSh 417/mo",
        kcbOffer: false,
        features: "30000mAh, LED Display, Triple Output",
        releaseDate: "2023-09-15",
        sales: 2678
    },
    {
        id: 336,
        name: "Native Union Belt Cable XL USB-C to Lightning 10ft",
        brand: "Native Union",
        category: "Accessories",
        type: "Cables",
        price: 2999,
        originalPrice: 3999,
        discount: 25,
        image: samsungcharger,
        rating: 4.7,
        reviews: 456,
        compatibility: "Mobile",
        connectivity: "Wired",
        powerOutput: "18W",
        stock: 178,
        emi: "KSh 250/mo",
        kcbOffer: false,
        features: "10ft Length, MFi Certified, Reinforced Design",
        releaseDate: "2023-10-05",
        sales: 1890
    }
];
